import React, { useEffect, useState } from "react";
import {
    Layout,
    Breadcrumb,
    Row,
    Col,
    Input,
    Button,
    Skeleton,
    List,
    Form,
    Checkbox,
    Select,
    message,
    Alert
} from "antd";
import { useParams, Link } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import Api from "../api";

const { Content } = Layout;

const AdventView = () => {
    const params = useParams();
    const [advent, setAdvent] = useState(null);
    const [giftType, setGiftType] = useState("");
    const [answers, setAnswers] = useState([]);
    const [badges, setBadges] = useState([]);
    const [giftHtml, setGiftHtml] = useState("");
    const [form] = Form.useForm();

    const types = [
        { label: "Show text", value: "text" },
        { label: "Give user points", value: "points" },
        { label: "Add +1 days to user account", value: "days" },
        { label: "Give user decoration", value: "decoration" },
        { label: "Show question", value: "question" }
    ];

    useEffect(() => {
        loadAdvent();
        Api.get("/admin/decorations").then(res => {
            setBadges(res.data.data);
        });
    }, []);

    const loadAdvent = () => {
        Api.get(`/admin/advent-calendar/${params.id}`).then(res => {
            setAdvent(res.data);
            setGiftType(res.data.gift_type);

            if (res.data.gift_type === "question" && res.data.questions.length) {
                setAnswers(res.data.questions[0].answers);
            }
        });
    };

    const onFinish = values => {
        // Question handling
        if (values.question_text) {
            const method =
                advent.questions && advent.questions.length ? "put" : "post";

            Api[method](
                `/admin/advent-calendar/${advent.id}/questions${
                    advent.questions?.length ? `/${advent.questions[0].id}` : ""
                }`,
                { question: values.question_text }
            ).then(res => {
                answers.forEach(answer => {
                    const type = answer.id ? "put" : "post";

                    Api[type](
                        `/admin/advent-calendar/${advent.id}/questions/${res.data.id}/answers${
                            answer.id ? `/${answer.id}` : ""
                        }`,
                        {
                            answer: answer.answer,
                            is_correct: answer.is_correct
                        }
                    );
                });
            });
        }

        // Advent update
        Api.put(`/admin/advent-calendar/${advent.id}`, {
            gift: giftHtml,
            gift_type: values.gift_type,
            points: values.points,
            decoration_id: values.decoration_id
        })
            .then(() => {
                loadAdvent();
                message.success("Advent day updated");
            })
            .catch(() => message.error("Updating failed"));
    };

    const addAnswer = () =>
        setAnswers([...answers, { answer: "", is_correct: false }]);

    const removeAnswer = (index, id) => {
        if (id) {
            Api.delete(
                `/admin/advent-calendar/${advent.id}/questions/${advent.questions[0].id}/answers/${id}`
            );
        }
        setAnswers(answers.filter((_, i) => i !== index));
    };

    const WinnerPicker = ({ correctUserAnswers }) => {
        const [winner, setWinner] = useState(null);

        const pick = () => {
            if (!correctUserAnswers?.length) return;
            const random =
                correctUserAnswers[
                    Math.floor(Math.random() * correctUserAnswers.length)
                    ];
            setWinner(random.user_id);
        };

        return (
            <div style={{ marginTop: 20 }}>
                <p>
                    Correct users count:{" "}
                    <strong>{correctUserAnswers.length}</strong>
                </p>
                <Button type="primary" onClick={pick}>
                    Pick Random Winner
                </Button>
                {winner && (
                    <p style={{ marginTop: 10 }}>
                        🎉 Winner User ID: <strong>{winner}</strong>
                    </p>
                )}
            </div>
        );
    };

    return (
        <Content style={{ margin: "0 16px" }}>
            <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Fitlap</Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/advent-calendar">Advent</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{params.id}</Breadcrumb.Item>
            </Breadcrumb>

            <div className="site-layout-card">
                <h1>Advent</h1>

                {!advent ? (
                    <Skeleton active />
                ) : (
                    <Row justify="center">
                        <Col span={24} md={16}>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                                initialValues={{
                                    gift_type: advent.gift_type,
                                    points: advent.points,
                                    decoration_id: advent.decoration_id,
                                    gift: advent.gift
                                }}
                            >
                                <Form.Item label="Type" name="gift_type">
                                    <Select
                                        options={types}
                                        onChange={setGiftType}
                                    />
                                </Form.Item>

                                {giftType === "points" && (
                                    <>
                                        <Alert
                                            type="warning"
                                            showIcon
                                            message="Points value"
                                            description="0 = move to next level | >0 = number of points"
                                        />
                                        <Form.Item label="Points" name="points">
                                            <Input type="number" />
                                        </Form.Item>
                                    </>
                                )}

                                {giftType === "decoration" && (
                                    <Form.Item
                                        label="Decoration"
                                        name="decoration_id"
                                    >
                                        <Select>
                                            {badges.map(b => (
                                                <Select.Option
                                                    key={b.id}
                                                    value={b.id}
                                                >
                                                    <img
                                                        src={b.image_url}
                                                        width={20}
                                                        alt=""
                                                        style={{
                                                            marginRight: 6
                                                        }}
                                                    />
                                                    {b.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                )}

                                <Form.Item label="Gift body" name="gift">
                                    <Editor
                                        onEditorChange={(content) => {
                                            setGiftHtml(content);
                                        }}
                                        apiKey={"ifldr77em1gvghkwv822nm1q2cv4p0349ju49t01qzamt7af"}
                                        init={{
                                            height: 300,
                                            menubar: false,
                                            plugins:
                                                "link image lists code",
                                            toolbar:
                                                "undo redo | bold italic underline | bullist numlist | link image | code",
                                            link_target_list: [
                                                {
                                                    title: "Same tab",
                                                    value: ""
                                                },
                                                {
                                                    title: "New tab",
                                                    value: "_blank"
                                                }
                                            ]
                                        }}
                                    />
                                </Form.Item>

                                {giftType === "question" && (
                                    <>
                                        <Form.Item
                                            label="Question"
                                            name="question_text"
                                            initialValue={
                                                advent.questions[0]?.question
                                            }
                                        >
                                            <Input />
                                        </Form.Item>

                                        <List
                                            dataSource={answers}
                                            renderItem={(a, i) => (
                                                <List.Item>
                                                    <Input
                                                        value={a.answer}
                                                        onChange={e => {
                                                            const copy =
                                                                [...answers];
                                                            copy[i].answer =
                                                                e.target.value;
                                                            setAnswers(copy);
                                                        }}
                                                        style={{
                                                            width: "70%",
                                                            marginRight: 8
                                                        }}
                                                    />
                                                    <Checkbox
                                                        checked={a.is_correct}
                                                        onChange={() => {
                                                            const copy =
                                                                [...answers];
                                                            copy[i].is_correct =
                                                                !copy[i]
                                                                    .is_correct;
                                                            setAnswers(copy);
                                                        }}
                                                    >
                                                        Correct
                                                    </Checkbox>
                                                    <Button
                                                        danger
                                                        onClick={() =>
                                                            removeAnswer(
                                                                i,
                                                                a.id
                                                            )
                                                        }
                                                    >
                                                        Remove
                                                    </Button>
                                                </List.Item>
                                            )}
                                        />

                                        <Button
                                            type="dashed"
                                            onClick={addAnswer}
                                            style={{ marginTop: 16 }}
                                        >
                                            Add Answer
                                        </Button>

                                        <WinnerPicker
                                            correctUserAnswers={
                                                advent.questions[0]
                                                    ?.correct_user_answers ||
                                                []
                                            }
                                        />
                                    </>
                                )}

                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    block
                                >
                                    Salvesta
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                )}
            </div>
        </Content>
    );
};

export default AdventView;
